const dias_options: any[] = [];

for (let i = 1; i <= 31; i++) {
    dias_options.push(i);
}

export default dias_options;
